<template>
    <div>
        <sweet-modal blocking :title="state === 'create' ? $t('modal_humanCapitalManagement_addPeriod') : $t('modal_humanCapitalManagement_editPeriod')" ref="addHumanCapitalPeriodModal" class="add-item-modal" v-on:close="close">
            <el-form label-position="left" :model="formAddPeriod" status-icon :rules="rules" ref="formAddPeriod" class="add-item-form">
                <el-form-item size="mini" prop="name">
                    <el-input :placeholder="$t('modal_humanCapitalManagement_name')" v-model="formAddPeriod.name"></el-input>
                </el-form-item>
                <div class="flex-end">
                    <el-form-item>
                        <el-button v-if="state === 'create'" @click="create('formAddPeriod')" class="modal__btn" type="primary" plain size="mini">{{$t('general_save')}}</el-button>
                        <el-button v-if="state === 'update'" @click="update('formAddPeriod', itemId)" class="modal__btn" type="primary" plain size="mini">{{$t('general_edit')}}</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </sweet-modal>
    </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios'
  export default {
    name: "HumanCapitalAddPeriodModal",
    components:{
      SweetModal
    },
    data(){
      return {
        type: null,
        state: 'create',
        itemId: null,
        formAddPeriod:{
          name: null,
        },
        rules: {
          name: [
            { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        }
      }
    },
    methods:{
      async open(){
        try {
          this.state = 'create';

          this.$refs.addHumanCapitalPeriodModal.open();

        } catch (err) {
          console.log(err)
        }
      },
      async openEdit(itemId) {
        try {
          this.state = 'update';
          this.itemId = itemId;

          const item = await this.item(itemId);

          this.$refs.addHumanCapitalPeriodModal.open();

        } catch (err) {
          console.log(err)
        }
      },
      item(itemId){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/workingHoursPeriod/item?companyId=${this.$route.query.companyId}&periodId=${itemId}`)
            .then(response => {
              console.log('response', response.data);
              this.formAddPeriod.name = response.data.fields.fields.name;
              loader.hide();
              resolve(response.data.item)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide();
              reject(error)
            });
        })
      },
      create(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            const data = {
              fields: {
                name: this.formAddPeriod.name
              }
            };
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/workingHoursPeriod/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                console.log('response', response.data);
                loader.hide();
                this.notification(this.$t('general_success'), this.$t('notification_humanCapitalPeriodAdded'), "success");
                this.$emit('loadList');
                this.$refs.addHumanCapitalPeriodModal.close();
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide();
              });
          } else {
            console.log('not valid')
          }
        })
      },
      update(form, itemId) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            const data = {
              fields: {
                name: this.formAddPeriod.name
              }
            };
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/workingHoursPeriod/update?companyId=${this.$route.query.companyId}&periodId=${itemId}`, data)
              .then(response => {
                console.log('response', response.data);
                loader.hide();
                this.notification(this.$t('general_success'), this.$t('notification_humanCapitalEditPeriod'), "success");
                this.$emit('loadList');
                this.$refs.addHumanCapitalPeriodModal.close();
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide();
              });
          } else {
            console.log('not valid')
          }
        })
      },
      close(){
        this.$refs['formAddPeriod'].resetFields();
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    }
  }
</script>

<style scoped>

</style>
